import { render, staticRenderFns } from "./premiumoffers.vue?vue&type=template&id=25621bf2&scoped=true&"
import script from "./premiumoffers.vue?vue&type=script&lang=js&"
export * from "./premiumoffers.vue?vue&type=script&lang=js&"
import style0 from "./premiumoffers.vue?vue&type=style&index=0&id=25621bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25621bf2",
  null
  
)

export default component.exports